import React from 'react';
import { LoaderColor } from './constants';
import { FullScreenContainer, AnimatedLoader } from './styles';

const loaderVariants = { animate: { rotate: 360 } };

const loaderTransition = {
  duration: 1,
  ease: 'linear',
  repeat: Infinity,
};

interface ILoaderProps {
  className?: string;
  color?: LoaderColor;
  fullScreen?: boolean;
}

export const Loader = ({
  className,
  color = LoaderColor.PRIMARY,
  fullScreen,
}: ILoaderProps) => {
  const Container = fullScreen ? FullScreenContainer : React.Fragment;

  return (
    <Container>
      <AnimatedLoader
        color={color}
        className={className}
        variants={loaderVariants}
        animate="animate"
        transition={loaderTransition}
      />
    </Container>
  );
};
